// test1028
(1028 && 0);
